export default __webpack_public_path__ + "static/media/logo-dubidoc-white.9725cfff.png";